import { AccommodationActivityClass } from "@/lib/builder/models/activity.model";

/**
 * Sdoppia un alloggio nelle due voci che il builder mostra: check-in sul giorno di
 * arrivo, check-out su quello di partenza.
 *
 * L'ancoraggio segue quello dell'attività: date reali su un itinerario collegato,
 * indici di giorno su un template (dove le date sono vuote).
 */
export const createCheckInOutActivities = (activityData: AccommodationActivityClass): AccommodationActivityClass[] => {
    const checkInDate = (activityData as any).check_in_date || activityData.start_date || (activityData as any).from_date;
    const checkOutDate = (activityData as any).check_out_date || activityData.end_date || (activityData as any).to_date;

    // `day_index` è generata a database da start_day_index: si legge come ripiego per i
    // dati vecchi, non si scrive.
    const checkInIndex = activityData.start_day_index ?? activityData.day_index ?? null;
    const checkOutIndex = activityData.end_day_index ?? checkInIndex;

    // Usa l'ID già generato dalla modale, altrimenti genera un UUID
    const generatedId = activityData.id || crypto.randomUUID();

    // Create check-in activity
    return [
        new AccommodationActivityClass({
            ...activityData,
            type: 'accommodation',
            inOrOutActivity: 'in',
            start_date: checkInDate,
            end_date: checkOutDate,
            start_day_index: checkInIndex,
            end_day_index: checkOutIndex,
            id: generatedId,
            date: activityData.start_date,
        }),
        new AccommodationActivityClass({
            ...activityData,
            type: 'accommodation',
            inOrOutActivity: 'out',
            start_date: checkOutDate,
            end_date: checkOutDate,
            start_day_index: checkOutIndex,
            end_day_index: checkOutIndex,
            id: generatedId + '-out',
            date: activityData.end_date,
        })
    ];
};
